var slice = window.slice;
var bind = window.bind;
var getValue = window.getValue;
var getValue,
  bind = function (fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
  slice = [].slice;
$w.modal_box = function (options, properties) {
  var box;
  if (properties == null) {
    properties = {};
  }
  box = new Widgets.ModalBox(options);
  box.on('shown', function () {
    return typeof options.after_show === "function" ? options.after_show(box) : void 0;
  });
  return box.show(properties);
};
Widgets.ModalBox = function () {
  ModalBox.prototype.template = _.template("<div class=modal_overlay> <div class=modal_overlay_box> <div class=modal_title_bar> <%= title %> <i class='fa fa-times'></i> </div> <div class='modal_contents clearfix'></div> </div> </div>");
  function ModalBox(options) {
    this._handle_window_keyup = bind(this._handle_window_keyup, this);
    _.extend(this, Backbone.Events);
    this.title = options.title || "";
    this.contents = options.contents || "";
    this.width = options.width || "600px";
    this.close_on_esc = options.close_on_esc != null ? options.close_on_esc : true;
    this._adjust_top_margin_throttled = _.throttle(function (_this) {
      return function () {
        return _this._adjust_top_margin();
      };
    }(this), 200);
  }
  ModalBox.prototype.show = function (properties) {
    $("#overlay_background").fadeIn(100, function (_this) {
      return function () {
        _this.$el = $(_this.template({
          title: getValue(_this.title, properties)
        }));
        _this.$el.find(".modal_contents").append(getValue(_this.contents, properties));
        _this.$el.find(".modal_overlay_box").css({
          width: _this.width
        });
        $(window).on("keyup", _this._handle_window_keyup);
        $(window).on("resize", _this._adjust_top_margin_throttled);
        $("body").addClass("no_scroll");
        $("body").append(_this.$el);
        _this._adjust_top_margin();
        _this._bind_events();
        return _this.trigger('shown');
      };
    }(this));
    return this;
  };
  ModalBox.prototype.hide = function () {
    this.$el.hide();
    return $("#overlay_background").fadeOut(200, function (_this) {
      return function () {
        _this.$el.remove();
        $(window).off("keyup", _this._handle_window_keyup);
        $(window).off("resize", _this._adjust_top_margin_throttled);
        $("body").removeClass("no_scroll");
        return _this.trigger('hidden');
      };
    }(this));
  };
  ModalBox.prototype._handle_window_keyup = function (e) {
    if (e.keyCode === 27 && this.close_on_esc) {
      e.preventDefault();
      e.stopPropagation();
      return this.hide();
    }
  };
  ModalBox.prototype._adjust_top_margin = function () {
    var box, box_height, margin, window_height;
    box = this.$el.find(".modal_overlay_box");
    box_height = box.outerHeight();
    window_height = $(window).height();
    if (box_height === 0) {
      return setTimeout(this._adjust_top_margin, 200);
    } else {
      margin = Math.max((window_height - box_height) / 2, 50);
      return box.css({
        marginTop: margin + "px"
      });
    }
  };
  ModalBox.prototype._bind_events = function () {
    this.$el.on("click", function (_this) {
      return function (e) {
        if ($(e.target).is(_this.$el)) {
          return _this.hide();
        }
      };
    }(this));
    this.$el.on("click", ".modal_title_bar i", function (_this) {
      return function (e) {
        return _this.hide();
      };
    }(this));
    this.$el.on("resize_modal", function (_this) {
      return function (e) {
        e.stopPropagation();
        return _this._adjust_top_margin();
      };
    }(this));
    return this.$el.on("hide_modal", function (_this) {
      return function (e) {
        e.stopPropagation();
        return _this.hide();
      };
    }(this));
  };
  return ModalBox;
}();
getValue = function () {
  var args, fn_or_value;
  fn_or_value = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  if (typeof fn_or_value === "function") {
    return fn_or_value.apply(null, args);
  } else {
    return fn_or_value;
  }
};
window.getValue = getValue;
window.bind = bind;
window.slice = slice;